import { render } from "./AvaliacaoTempoCasa.vue?vue&type=template&id=08f6145d"
import script from "./AvaliacaoTempoCasa.vue?vue&type=script&lang=js"
export * from "./AvaliacaoTempoCasa.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__